/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/number/LeftRotate.ts
 * @create:      2025-06-27 10:43:28.163
 * @modify:      2025-07-11 21:19:12.822
 * @version:     6.0.0
 * @times:       20
 * @lines:       60
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { BitString } from "../class/BitString";

/**
 * Performs a left bitwise rotation on a given number.
 *
 * @param n - The number to rotate.
 * @param bits - The number of bits to rotate to the left.
 * @param totalBits - The total number of bits to consider for the rotation (defaults to 32).
 * @returns The result of rotating `n` to the left by `bits` positions within `totalBits` bits.
 *
 * @since 4.0.0
 * @version 2025-06-27
 */
export function LeftRotate(n: number, bits: number, totalBits?: number) {
    totalBits ??= 32;
    bits = bits % totalBits;

    if (totalBits === 32) {
        return ((n << bits) | (n >>> (totalBits - bits))) >>> 0;
    }

    const bs = new BitString(n);
    bs.SetLength(totalBits);
    const result = bs.LeftRotate(bits, totalBits);

    return result.ToNumber();
}
